import { ProjectVirtualGraphsToCreate } from 'src/containers/ProjectResourceDialog/ProjectVirtualGraphCreationPanel/types';

export const getCustomQueryFromVgsToCreate = (
  virtualGraphsToCreate: ProjectVirtualGraphsToCreate
) => {
  return Object.values(virtualGraphsToCreate).find(
    (virtualGraphToCreate) => typeof virtualGraphToCreate.from === 'string'
  );
};
